import { defineMessages } from 'react-intl';

/** The story step and the style step (design directed-video c1 to c3, d1, d2, j2). */
export const storyMessages = defineMessages({
  // Stories (c1, c3)
  storiesTitle: { id: 'app.sml.musicVideo.directed.stories.title', defaultMessage: 'Pick a story' },
  storiesIntro: {
    id: 'app.sml.musicVideo.directed.stories.intro',
    defaultMessage:
      'The director read {title}, its lyrics and your cast, and wrote three ideas. Pick one and change any word of it, or ask for three new ones.',
  },
  storiesEditIntro: {
    id: 'app.sml.musicVideo.directed.stories.editIntro',
    defaultMessage: 'Change any word. The director writes the styles and the script from your text.',
  },
  idea: { id: 'app.sml.musicVideo.directed.stories.idea', defaultMessage: 'Idea {number}' },
  pick: { id: 'app.sml.musicVideo.directed.choice.pick', defaultMessage: 'Pick' },
  picked: { id: 'app.sml.musicVideo.directed.choice.picked', defaultMessage: 'Picked' },
  edit: { id: 'app.sml.musicVideo.directed.choice.edit', defaultMessage: 'Edit' },
  edited: { id: 'app.sml.musicVideo.directed.choice.edited', defaultMessage: 'Edited' },
  done: { id: 'app.sml.musicVideo.directed.choice.done', defaultMessage: 'Done' },
  undo: { id: 'app.sml.musicVideo.directed.choice.undo', defaultMessage: 'Undo my changes' },
  cancel: { id: 'app.sml.musicVideo.directed.choice.cancel', defaultMessage: 'Cancel' },
  fieldTitle: { id: 'app.sml.musicVideo.directed.stories.fieldTitle', defaultMessage: 'Title' },
  fieldLogline: { id: 'app.sml.musicVideo.directed.stories.fieldLogline', defaultMessage: 'The idea in one line' },
  fieldBeats: { id: 'app.sml.musicVideo.directed.stories.fieldBeats', defaultMessage: 'Beats' },
  beatsLink: {
    id: 'app.sml.musicVideo.directed.stories.beatsLink',
    defaultMessage: 'Edit · See the {count, plural, one {# beat} other {# beats}}',
  },
  storiesAgainHint: {
    id: 'app.sml.musicVideo.directed.stories.againHint',
    defaultMessage: 'Tell the director what to change: less sad, more about the band, set it in a city…',
  },
  storiesAgain: { id: 'app.sml.musicVideo.directed.stories.again', defaultMessage: 'Write 3 new ideas' },
  storiesAgainPhone: { id: 'app.sml.musicVideo.directed.stories.againPhone', defaultMessage: '3 new ideas' },
  backToCast: { id: 'app.sml.musicVideo.directed.stories.backToCast', defaultMessage: 'Back to the cast' },
  storiesNext: {
    id: 'app.sml.musicVideo.directed.stories.next',
    defaultMessage: 'Next: the director writes 3 filming styles for this story',
  },
  useStory: { id: 'app.sml.musicVideo.directed.stories.use', defaultMessage: 'Use this story' },
  noStories: {
    id: 'app.sml.musicVideo.directed.stories.none',
    defaultMessage: 'The director has no ideas for this video yet.',
  },
  writeStories: { id: 'app.sml.musicVideo.directed.stories.write', defaultMessage: 'Write 3 stories' },
  changeStoryTitle: {
    id: 'app.sml.musicVideo.directed.stories.changeTitle',
    defaultMessage: 'Change the story?',
  },
  changeStoryText: {
    id: 'app.sml.musicVideo.directed.stories.changeText',
    defaultMessage: 'The styles and the script are written again. This uses one director run.',
  },
  changeStoryConfirm: { id: 'app.sml.musicVideo.directed.stories.changeConfirm', defaultMessage: 'Change the story' },

  // Styles (d1, d2)
  styleTitle: { id: 'app.sml.musicVideo.directed.style.title', defaultMessage: 'How should it look?' },
  styleIntro: {
    id: 'app.sml.musicVideo.directed.style.intro',
    defaultMessage:
      'Three ways to film “{story}”. The style goes into every shot, so the colour and the light stay the same from the first shot to the last.',
  },
  styleOwnIntro: {
    id: 'app.sml.musicVideo.directed.style.ownIntro',
    defaultMessage: 'Your words go into every shot. Short and concrete works best.',
  },
  styleNumber: { id: 'app.sml.musicVideo.directed.style.number', defaultMessage: 'Style {number}' },
  yourOwn: { id: 'app.sml.musicVideo.directed.style.yourOwn', defaultMessage: 'Your own' },
  yourLook: { id: 'app.sml.musicVideo.directed.style.yourLook', defaultMessage: 'Your look' },
  writeOwn: { id: 'app.sml.musicVideo.directed.style.writeOwn', defaultMessage: 'Write my own' },
  writeOwnText: {
    id: 'app.sml.musicVideo.directed.style.writeOwnText',
    defaultMessage:
      'Describe the camera, the colour and the light, the texture and the pace in your words. A reference film or video helps: “like an old home video”.',
  },
  camera: { id: 'app.sml.musicVideo.directed.style.camera', defaultMessage: 'Camera' },
  colourLight: { id: 'app.sml.musicVideo.directed.style.colourLight', defaultMessage: 'Colour, light' },
  colourAndLight: { id: 'app.sml.musicVideo.directed.style.colourAndLight', defaultMessage: 'Colour and light' },
  texture: { id: 'app.sml.musicVideo.directed.style.texture', defaultMessage: 'Texture' },
  pacing: { id: 'app.sml.musicVideo.directed.style.pacing', defaultMessage: 'Pacing' },
  effects: { id: 'app.sml.musicVideo.directed.style.effects', defaultMessage: 'Effects' },
  effectsToLean: { id: 'app.sml.musicVideo.directed.style.effectsToLean', defaultMessage: 'Effects to lean on' },
  name: { id: 'app.sml.musicVideo.directed.style.name', defaultMessage: 'Name' },
  familyLyric: { id: 'app.sml.musicVideo.directed.style.family.lyric', defaultMessage: 'Lyric moments' },
  familyTitle: { id: 'app.sml.musicVideo.directed.style.family.title', defaultMessage: 'Titles and chapters' },
  familyTransition: { id: 'app.sml.musicVideo.directed.style.family.transition', defaultMessage: 'Transitions' },
  familyShot: { id: 'app.sml.musicVideo.directed.style.family.shot', defaultMessage: 'Shot effects' },
  familyLyricHint: {
    id: 'app.sml.musicVideo.directed.style.family.lyricHint',
    defaultMessage: 'Lines of your lyrics on screen as they are sung.',
  },
  familyTitleHint: {
    id: 'app.sml.musicVideo.directed.style.family.titleHint',
    defaultMessage: 'The song title and a card at each new part.',
  },
  familyTransitionHint: {
    id: 'app.sml.musicVideo.directed.style.family.transitionHint',
    defaultMessage: 'Designed cuts between shots: flashes, wipes, blurs.',
  },
  familyShotHint: {
    id: 'app.sml.musicVideo.directed.style.family.shotHint',
    defaultMessage: 'Effects over a shot: shake, pulse, glitch.',
  },
  familiesHint: {
    id: 'app.sml.musicVideo.directed.style.familiesHint',
    defaultMessage: 'Switch an effect off and the script gets none of it.',
  },
  familiesNone: {
    id: 'app.sml.musicVideo.directed.style.familiesNone',
    defaultMessage: 'No effects: the video shows only the shots.',
  },
  effectsOf: { id: 'app.sml.musicVideo.directed.style.effectsOf', defaultMessage: 'Effects of {style}' },
  familyOn: { id: 'app.sml.musicVideo.directed.style.familyOn', defaultMessage: 'On' },
  familyOff: { id: 'app.sml.musicVideo.directed.style.familyOff', defaultMessage: 'Off' },
  ownInvalid: {
    id: 'app.sml.musicVideo.directed.style.ownInvalid',
    defaultMessage: 'Give the style a name and one more line.',
  },
  stylesAgainHint: {
    id: 'app.sml.musicVideo.directed.style.againHint',
    defaultMessage: 'Tell the director what to change: darker, more colour, no hand-held camera…',
  },
  stylesAgain: { id: 'app.sml.musicVideo.directed.style.again', defaultMessage: 'Write 3 new styles' },
  stylesAgainPhone: { id: 'app.sml.musicVideo.directed.style.againPhone', defaultMessage: '3 new styles' },
  backToStory: { id: 'app.sml.musicVideo.directed.style.backToStory', defaultMessage: 'Back to the story' },
  styleNext: {
    id: 'app.sml.musicVideo.directed.style.next',
    defaultMessage: 'Next: the director writes the script, shot by shot',
  },
  useStyle: { id: 'app.sml.musicVideo.directed.style.use', defaultMessage: 'Use this style' },
  noStyles: {
    id: 'app.sml.musicVideo.directed.style.none',
    defaultMessage: 'The director has no styles for this story yet.',
  },
  writeStyles: { id: 'app.sml.musicVideo.directed.style.write', defaultMessage: 'Write 3 styles' },
  changeStyleTitle: { id: 'app.sml.musicVideo.directed.style.changeTitle', defaultMessage: 'Change the style?' },
  changeStyleText: {
    id: 'app.sml.musicVideo.directed.style.changeText',
    defaultMessage: 'The script is written again. This uses one director run.',
  },
  changeStyleConfirm: { id: 'app.sml.musicVideo.directed.style.changeConfirm', defaultMessage: 'Change the style' },
});
